// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IValueTemplateDto } from './IValueTemplateDto';
import {
    IValueTemplateDtoFromJSON,
    IValueTemplateDtoFromJSONTyped,
    IValueTemplateDtoToJSON,
    IValueTemplateDtoToJSONTyped,
} from './IValueTemplateDto';

/**
 * 
 * @export
 * @interface IAuditLogInfoDto
 */
export interface IAuditLogInfoDto {
    /**
     * 
     * @type {number}
     * @memberof IAuditLogInfoDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IAuditLogInfoDto
     */
    field_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IAuditLogInfoDto
     */
    old_value?: string;
    /**
     * 
     * @type {string}
     * @memberof IAuditLogInfoDto
     */
    new_value?: string;
    /**
     * 
     * @type {IValueTemplateDto}
     * @memberof IAuditLogInfoDto
     */
    new_value_template?: IValueTemplateDto;
}

/**
 * Check if a given object implements the IAuditLogInfoDto interface.
 */
export function instanceOfIAuditLogInfoDto(value: object): value is IAuditLogInfoDto {
    return true;
}

export function IAuditLogInfoDtoFromJSON(json: any): IAuditLogInfoDto {
    return IAuditLogInfoDtoFromJSONTyped(json, false);
}

export function IAuditLogInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAuditLogInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'field_name': json['field_name'] == null ? undefined : json['field_name'],
        'old_value': json['old_value'] == null ? undefined : json['old_value'],
        'new_value': json['new_value'] == null ? undefined : json['new_value'],
        'new_value_template': json['new_value_template'] == null ? undefined : IValueTemplateDtoFromJSON(json['new_value_template']),
    };
}

export function IAuditLogInfoDtoToJSON(json: any): IAuditLogInfoDto {
    return IAuditLogInfoDtoToJSONTyped(json, false);
}

export function IAuditLogInfoDtoToJSONTyped(value?: IAuditLogInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'field_name': value['field_name'],
        'old_value': value['old_value'],
        'new_value': value['new_value'],
        'new_value_template': IValueTemplateDtoToJSON(value['new_value_template']),
    };
}

